// src/utils/activityLogger.js
import fc from '@/firebaseConfig'

const logActivity = (eventName, params) => {
  if (fc.analytics) {
    fc.analytics.logEvent(eventName, params)
  }
}

export default logActivity
